export enum SearchTriggerLocation {
  Enter = 'enter',
  SeeAllButton = 'see_all_results',
}
